export type JsonPath = (string | number)[];

export const isContainer = (value: unknown): value is object => typeof value === 'object' && value !== null;

/** Returns a copy of `root` with the value at `path` replaced */
export function setJsonValue(root: unknown, path: JsonPath, value: unknown): unknown {
  if (path.length === 0) return value;
  const [key, ...rest] = path;
  if (Array.isArray(root)) {
    const copy = [...root];
    copy[key as number] = setJsonValue(root[key as number], rest, value);
    return copy;
  }
  const obj = (isContainer(root) ? root : {}) as Record<string, unknown>;
  return { ...obj, [key]: setJsonValue(obj[key as string], rest, value) };
}
